import mainComponent from '@/layouts/main/Main.vue'

export default [{
  path: '/pedidos',
  component: mainComponent,
  title: 'Pedidos',
  children: [{
    path: '/',
    name: 'order-list',
    component: () => import('@/views/order/OrdersList.vue'),
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Comercial' },
        { title: 'Pedidos', active: true },
      ],
      pageTitle: 'Pedidos',
      rule: 'editor'
    },
  }, ],
}, ];